import React from "react";
import Select, { components } from "react-select";
import { ChevronDownIcon } from "@heroicons/react/24/solid";

export const SingleSelectComponent = ({
  isIconWithOption = true,
  placeholder = "Select an option",
  handleSelection,
  selectedOption,
  selectClass = "",
  parentClass = "",
  options = [],
  error,
  validationMsgs,
  label,
  customHeight = "32px",
  customMenuHeight = "400px",
  menuPlacement = "auto",
  useMinWidth = true,
}) => {
  const customStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: customHeight,
      height: "auto",
      borderWidth: "1px",
      borderColor: error ? "#C10700" : state.isFocused ? "#F46C3C" : "#D9D9D9",
      color: state.isSelected ? "#F46C3C" : "#7E7E7E",
      boxShadow: "none",
      "&:hover": {
        borderColor: error ? "#C10700" : state.isFocused ? "#F46C3C" : "black",
      },
      padding: "4px 16px",
      paddingRight: isIconWithOption ? "12px" : "16px",
      // paddingLeft: isIconWithOption ? "12px" : "16px",
      borderRadius: "12px",
      cursor: "pointer",
      gap: "4px",
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "0px",
    }),
    input: (base) => ({
      ...base,
      padding: "0px",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#7E7E7E",
      fontSize: "14px",
      fontWeight: "500",
      padding: "0px !important",
    }),
    menu: (base) => ({
      ...base,
      padding: "6px",
      backgroundColor: "#FFFFFF",
      borderRadius: "8px",
      boxShadow: "0px 4px 12px 0px #7E7E7E29",
      minWidth: `${useMinWidth ? "300px" : "0px"}`,
    }),
    option: (base, { isFocused, isSelected }) => ({
      ...base,
      backgroundColor: isSelected ? "#FFEEE5" : isFocused ? "#F5F5F5" : "#FFFFFF",
      color: isSelected ? "#F46C3C" : "#000000",
      paddingTop: "12px",
      paddingBottom: "16px",
      paddingRight: "16px",
      display: "flex",
      fontSize: "14px",
      fontWeight: "500",
      alignItems: "center",
      gap: "4px",
      cursor: "pointer",
      borderRadius: "8px",
      "&:active": {
        backgroundColor: isSelected ? "#FFEEE5" : "#F0F0F0",
      },
    }),
    singleValue: (base, state) => ({
      ...base,
      color: state?.hasValue ? "#F46C3C" : "#7E7E7E",
      fontWeight: "500",
      fontSize: "14px",
      display: "flex",
      alignItems: "center",
      gap: "2px",
    }),
    dropdownIndicator: (base, state) => ({
      ...base,
      color: state?.hasValue ? "#F46C3C" : "#7E7E7E",
      padding: "0px",
    }),
    indicatorSeparator: () => ({ display: "none" }),
  };

  const DropdownIndicator = (props) => {
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
          <ChevronDownIcon className={`w-4 h-4 stroke-dark`} />
        </components.DropdownIndicator>
      )
    );
  };

  return (
    <div className={`flex flex-col gap-2 ${parentClass} `}>
      {label && <label className="ml-1 text-sm font-medium">{label}</label>}
      <Select
        value={selectedOption}
        onChange={handleSelection}
        options={options}
        styles={customStyles}
        placeholder={placeholder}
        components={{ DropdownIndicator }}
        menuPosition="fixed"
        menuPlacement={menuPlacement}
        maxMenuHeight={customMenuHeight}
        autoHeight={false}
        // getOptionLabel={(e) => (
        //   <div className="flex items-center gap-2">
        //     {e.icon && <span>{e.icon}</span>}
        //     {e.label}
        //   </div>
        // )}
        className={`${
          useMinWidth ? "min-w-72" : "min-w-0"
        } w-full border-grey-border text-sm rounded-xl cursor-pointer ${selectClass} m-0`}
      />
      {error && (
        <span className="ml-1 text-red text-xs font-bold">{validationMsgs?.[error] || error}</span>
      )}
    </div>
  );
};
